
  console.log("Hello World")
  document.addEventListener('click', function (event) {
    console.log(event)
    const header = event.target.closest(
      '#apd-root-modal .apd-acc-section-header'
    );

    if (!header) return;

    const section = header.closest('.apd-acc-section');
    const content = section?.querySelector('.apd-acc-content');

    if (!section || !content) return;

    const isOpen = section.classList.contains('is-open');

    // Close all other accordion sections
    document
      .querySelectorAll('#apd-root-modal .apd-acc-section.is-open')
      .forEach(function (openSection) {
        if (openSection === section) return;

        const openContent = openSection.querySelector('.apd-acc-content');

        openSection.classList.remove('is-open');

        if (openContent) {
          openContent.style.maxHeight = '0px';
        }
      });

    // Toggle clicked accordion
    if (isOpen) {
      section.classList.remove('is-open');
      content.style.maxHeight = '0px';
    } else {
      section.classList.add('is-open');
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
